import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';
export const Hero = () => {
  return <div className="relative h-screen w-full overflow-hidden" data-id="element-71">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0" data-id="element-72">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cX4TqtEeY7qa8xQbUUVRsm/ChatGPT_Image_Nov_9%2C_2025%2C_05_28_07_PM.png" alt="Woman singing with soul" className="object-cover w-full h-full" data-id="element-73" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/90" data-id="element-74"></div>
        {/* Animated light rays */}
        <motion.div className="absolute inset-0 opacity-20 bg-gradient-radial from-red-600/30 via-transparent to-transparent" animate={{
        scale: [1, 1.1, 1],
        opacity: [0.15, 0.25, 0.15]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-75" />
      </div>
      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1
      }} className="absolute top-8 right-8" data-id="element-77">
          <Logo data-id="element-78" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.3
      }} className="text-center max-w-3xl mx-auto" data-id="element-79">
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold mb-4 text-white" data-id="element-80">
            Praise Karaoke
          </h1>
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-light mb-6 text-white/90" data-id="element-81">
            Where Every Voice Becomes Worship
          </h2>
          <p className="text-lg sm:text-xl mb-10 text-white/80" data-id="element-82">
            A gospel worship experience of song, praise, and collective joy.
          </p>
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-brand-red hover:bg-red-700 text-white font-bold py-3 px-8 rounded-full text-lg transition-colors" data-id="element-83">
            Join the Praise →
          </motion.button>
        </motion.div>
      </div>
    </div>;
};